import {withIMask} from './components/withIMask';
import {SpartanTextField} from './SpartanTextField';

export const SpartanSocialField = withIMask(SpartanTextField, {mask: '000-00-0000'});
